import React from "react";
import IntrGlobal from "./globalView/intrGlobalView";
const INTRLossToAction = () => {        
    return <IntrGlobal/> 
};

export default INTRLossToAction;